export default __webpack_public_path__ + "static/media/calculation.ed6eceb8.png";